import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
// import of some global styles can be deleted if you don't use them
import colorVariables from '../../Globals/colors.module.css'
import fontVariables from '../../Globals/fonts.module.css'

import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import MainChart from 'components/MainChart'
import data_48 from 'Assets/data_48.json'
import data_49 from 'Assets/data_49.json'
import data_50 from 'Assets/data_50.json'
import data_51 from 'Assets/data_51.json'
import { Scroller } from 'components/Scroller'
import { useWindowSize } from 'usehooks-ts'
import { scenes } from 'Constants/Scenes'
import Chooser from 'components/CategoryChooser/CategoryChooser'
const legislatures = [data_51]
const MainComponent: FC<MicroFrontendProps> = ({
  tenant,
  colorMode,
}): ReactElement => {
  const globalClasses = [
    colorVariables.globalColors,
    fontVariables.globalFonts,
    colorMode === 'dark' ? colorVariables.globalColorsDark : '',
  ]
  const firstLegislature = 48
  const { width, height } = useWindowSize()
  const ALL_CATEGORIES = [
    'all',
    'migration',
    'finance',
    'economy',
    'environment',
    'social',
  ] as (keyof CouncilMember)[]

  const [currentIndex, setCurrentIndex] = useState<number>(0)
  // override legislature should be set to null when scene changes
  const [overrideLegislature, setOverrideLegislature] =
    useState<NationalCouncilLegislature | null>()
  const lastScene = useRef<number>(0)
  return (
    <AppContainer className={globalClasses.join(' ')}>
      <Scroller
        currentIndex={currentIndex}
        setCurrentIndex={setCurrentIndex}
        defaultDistance={height}
        front={scenes.map((scene) => scene.frontElement)}
        back={(index, element) => {
          // check if scene changed if so reset override legislature
          if (index !== lastScene.current) {
            setOverrideLegislature(null)
          }
          const currentScene = scenes[Math.min(index, scenes.length - 1)]
          const currentLegislatureData =
            overrideLegislature ?? currentScene.legislature
          lastScene.current = index
          return (
            <BackWrapper>
              <BehindChart>
                <Title>{currentScene.title}</Title>
                <Chooser
                  currentElement={currentLegislatureData}
                  setCurrentElement={setOverrideLegislature}
                  allElements={legislatures}
                  allElementLabels={['51. Legislatur']}
                />
              </BehindChart>
              <MainChart
                showSinglePoints={true}
                data={currentLegislatureData}
                categoryToDisplay={currentScene.category}
                xScaleExtent={[-0.35, 1]}
                partyFilter={currentScene.partyFilter}
                highlightCouncilMembers={currentScene.highlightMembers}
              />
            </BackWrapper>
          )
        }}
      />
    </AppContainer>
  )
}
const Title = styled.div`
  font-size: 3rem;
  line-height: 3rem;
  font-weight: 700;
  font-family: var(--font-serif);
  /* padding-top: 4rem; */
`
const BackWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const BehindChart = styled.div`
  width: 100%;
  height: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  backdrop-filter: blur(4px);
  mask-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 1) 40%,
    rgba(0, 0, 0, 1) 80%,
    rgba(0, 0, 0, 1)
  );
`
const AppContainer = styled(TamediaStyles)`
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  /* overflow-y: hidden; */
`
export default MainComponent
